module.exports = {"350681100":"石码镇","350681101":"海澄镇","350681102":"角美镇","350681103":"白水镇","350681104":"浮宫镇","350681105":"程溪镇","350681106":"港尾镇","350681107":"九湖镇","350681108":"颜厝镇","350681109":"榜山镇","350681110":"紫泥镇","350681111":"东园镇","350681200":"东泗乡","350681201":"隆教畲族乡","350681400":"双第华侨农场","350681401":"九龙岭林场","350681402":"程溪农场","350681403":"良种场","350681405":"林下林场","350681501":"招商局漳州开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350681.json
// module id = 1331
// module chunks = 0